import { http, type Page } from '@shared/api';
import type { ConversationView, MessageView, SendMessageRequest } from '../model/types';

export const chatApi = {
  listConversations: (page = 0, size = 20) =>
    http
      .get('conversations', { searchParams: { page: String(page), size: String(size) } })
      .json<Page<ConversationView>>(),

  getConversation: (id: string) => http.get(`conversations/${id}`).json<ConversationView>(),

  listMessages: (id: string, page = 0, size = 50) =>
    http
      .get(`conversations/${id}/messages`, {
        searchParams: { page: String(page), size: String(size) },
      })
      .json<Page<MessageView>>(),

  sendMessage: (id: string, body: SendMessageRequest) =>
    http.post(`conversations/${id}/messages`, { json: body }).json<MessageView>(),

  markRead: (id: string) => http.post(`conversations/${id}/read`).json<void>(),

  unreadCount: () => http.get('conversations/unread-count').json<{ count: number }>(),
};
